import React, { FC } from "react";
import { observer } from "mobx-react";
import { NavigateFunction } from "react-router-dom";
import MinusIcon from "../../../../../images/products/minus-blue.svg";
import Plus from "../../../../../images/products/plus.svg";
import { PurchaseStore } from "../store";
import {
  CustomerFacingCheckOutItemModel,
  RelatedItemsCategoriesModel,
} from "../models";
import { ICheckOutCombinedColors } from "../interfaces";
import { CheckOutButtonStyle } from "../enums";
import { FreeItemWrapper, MultiplePriceWrapper } from "../styles";
import {
  CustomButton,
  CustomLabel,
  FlexContainer,
  Input,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import CarousalWithThumbnail from "./CarousalWithThumbnail";
import PurchasePriceDescriptionRow from "./PurchasePriceDescriptionRow";
import ItemNotAvailableWarning from "./ItemNotAvailableWarning";
import CustomPricingInput from "./CustomPricingInput";
import ImgPlaceholder from "../../../../../images/placeholders/no-image.svg";
import { sanitizeHtml } from "../utils/sanitizeHtml";

type IProps = { 
  item: CustomerFacingCheckOutItemModel;
  navigate: NavigateFunction;
  onPurchaseClick: (
    item: CustomerFacingCheckOutItemModel,
    quantity: number
  ) => void;
  colors: ICheckOutCombinedColors;
  buttonCaption: string;
  buttonStyle: keyof typeof CheckOutButtonStyle;
  updateItem: (items: CustomerFacingCheckOutItemModel) => void;
  allowIncludedItems?: boolean;
};

const PurchaseSection: FC<IProps> = ({
  onPurchaseClick,
  item,
  colors,
  buttonCaption,
  buttonStyle,
  updateItem,
  allowIncludedItems,
}) => {
  const [quantity, setQuantity] = React.useState(item?.quantity);
  const [showError, setShowError] = React.useState(false);
  if (!item) {
    return null;
  }
  // const { name, description, cost } = purchaseStore.purchaseSectionData.productData;
  // const media = purchaseStore.purchaseSectionData.media;

  const renderFreeItemSection = (item: RelatedItemsCategoriesModel) => {
    const imageMedia = item.medias.find((m) => m.isImage());
    return (
      <div key={item.id}>
        <FreeItemWrapper>
          {imageMedia ? (
            <img src={imageMedia.fullURL} alt="image" />
          ) : (
            <img src={ImgPlaceholder} alt="image" />
          )}
          <CustomLabel className="flex-auto-grow">
            Get a <span className="highlighted-black">Free {item.name} </span>
            with purchase
          </CustomLabel>
        </FreeItemWrapper>
      </div>
    );
  };

  const onQuantityChange = (increment: boolean, quantity: number) => {
    if (increment) {
      quantity++;
    } else {
      quantity--;
    }
    if (
      item.inventorySettings &&
      item.inventorySettings.isLimitPurchaseQuantity &&
      quantity > item.inventorySettings.quantityLimit
    ) {
      setShowError(true);
      return;
    }
    setQuantity(quantity);
  };

  const renderQuantitySection = () => {
    let hasError = false;
    hasError = item.hasError("quantity");

    return (
      <>
        {/* <CustomLabel fontWeight="600" margin="15px 0px 0px">
          QUANTITY
        </CustomLabel> */}
        <FlexContainer
          alignItems="center"
          spacing={10}
          padding="20px 0px 0px"
          className="option-qty"
          margin="0px 0px 20px 0px"
        >
          {quantity > 1 && (
            <img
              src={MinusIcon}
              alt="Delete Icon"
              onClick={() =>
                !item.isItemUnavailable && onQuantityChange(false, quantity)
              }
              style={{
                cursor: !item.isItemUnavailable ? "pointer" : "not-allowed",
              }}
            />
          )}
          <Input
            type="text"
            error={hasError}
            value={quantity}
            disabled={true}
            onChange={() => {}}
          />
          {/* <input type="text" value={quantity} disabled={true} /> */}
          <img
            src={Plus}
            alt="Add"
            style={{
              cursor: !item.isItemUnavailable ? "pointer" : "not-allowed",
            }}
            onClick={() =>
              !item.isItemUnavailable && onQuantityChange(true, quantity)
            }
          />
        </FlexContainer>
      </>
    );
  };

  const showCheckOutAddOns = () => {
    if (!item.requiredItems && !item.recommendedItems) {
      return false;
    }
    return (
      (item.requiredItems && item.requiredItems.length > 0) ||
      (item.recommendedItems && item.recommendedItems?.length > 0)
    );
  };

  return (
    <MultiplePriceWrapper>
      <FlexContainer
        spacing={30}
        className="divided-component wrapped-columns wrapped-max-width"
        justifyContent="center"
      >
        {item.getAllMedias(true)?.length > 0 ? (
          <div className="caraousel-desc-width">
            {/* <ItemMediaSection  medias={item.fullURL || []}  /> */}
            <CarousalWithThumbnail
              media={item.getAllMedias(true) ?? []}
              className="option-carousel-wrapper"
            />
          </div>
        ) : (
          ""
        )}
        <div
          className={
            item.getAllMedias(true).length < 1 ? "right-panel-wo-media" : ""
          }
        >
          <FlexContainer
            justifyContent={
              item.getAllMedias(true).length < 1 ? "flex-start" : "center"
            }
            fxLayout="column"
            padding="0px 20px"
            className="item-right-panel"
          >
            {" "}
            {item.name && (
              <CustomLabel
                className="item-header"
                margin="0px 0px 30px"
                color="#000"
              >
                {item.name}
              </CustomLabel>
            )}
            {item.description !== "" && (
              <CustomLabel
                margin="0px 0px 15px"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(UtilityMethods.getEditorHtmlContent(
                    item.descriptionEditorRawContent
                  )),
                }}
              />
            )}
            {/* <CustomLabel>
                                <span className="semi-bold">{`$${55} USD `}</span> / month
                            </CustomLabel> */}
            {!item.isCustomPricing() && (
              <div>
                <PurchasePriceDescriptionRow
                  billingType={item.price.billingType}
                  terms={item.price.terms}
                  recurrence={item.price.recurrence}
                  priceId={item.price.id}
                  itemType={item.itemType}
                  hasVariants={item.hasVariants}
                  variants={item.variants}
                  quantity={quantity}
                  className="price-centered-row price-in-single-row"
                />
              </div>
            )}
            {!showCheckOutAddOns() &&
              !item.hasVariants &&
              renderQuantitySection()}
            {showError && (
              <p className="error-message">
                Only {item.inventorySettings?.quantityLimit || 0} items are
                allowed per purchase.
              </p>
            )}
            {item.isCustomPricing() && (
              <div>
                <CustomPricingInput
                  value={item.customPricingInputValue}
                  suggestedPrice={item.getCustomPricing()?.preset}
                  hasError={item.hasError("customPricingInputValue")}
                  errorMessage={item.getError("customPricingInputValue")}
                  onChange={(value) =>
                    updateItem(
                      new CustomerFacingCheckOutItemModel({
                        ...item,
                        customPricingInputValue: value,
                      })
                    )
                  }
                />
              </div>
            )}
            {allowIncludedItems &&
              item.includedItems &&
              item.includedItems.length > 0 && (
                <FlexContainer
                  fxLayout="column"
                  spacing={20}
                  padding="20px 0px"
                  width="auto"
                >
                  {item.includedItems.map((includedItem) =>
                    renderFreeItemSection(includedItem)
                  )}
                </FlexContainer>
              )}
            <CustomButton
              roundedRect={
                buttonStyle === CheckOutButtonStyle.SquareRoundCorner
                  ? true
                  : false
              }
              pillShape={
                buttonStyle === CheckOutButtonStyle.Round ? true : false
              }
              borderRadius={
                buttonStyle === CheckOutButtonStyle.Square ? "0px" : "4px"
              }
              bgColor={colors?.primary?.rgba}
              className="purchase-main-btn height-50 purchase-default-btn"
              //    disabled={item.hasError('customPricingInputValue')}
              onClick={() =>
                !item.isItemUnavailable && onPurchaseClick(item, quantity)
              }
              disabled={item.isItemUnavailable}
            >
              {buttonCaption}
            </CustomButton>
            {item.isItemUnavailable && <ItemNotAvailableWarning />}
          </FlexContainer>
        </div>
      </FlexContainer>
    </MultiplePriceWrapper>
  );
};

export default withRouter(observer(PurchaseSection));
